import React from 'react';
import s from "./SelectBasic.module.css";

import Select, {StylesConfig} from 'react-select';
import {DropdownIndicator} from "../DropdownIndicator";

interface SelectBasicProps {
    options: Array<[string, string]>;
    onChange: (value: string | null) => void;
    selected?: string;
    disabled?: boolean;
}

interface SelectOption {
    value: string;
    label: string;
}

export const SelectBasic: React.FC<SelectBasicProps> = ({
                                                            options,
                                                            onChange,
                                                            selected,
                                                            disabled = false,
                                                        }) => {
    // Преобразуем опции в формат react-select
    const selectOptions: SelectOption[] = options.map(([value, label]) => ({
        value,
        label
    }));

    // Находим выбранную опцию
    const selectedOption = selected
        ? selectOptions.find(option => option.value === selected)
        : null;

    const customStyles: StylesConfig<SelectOption, false> = {
        menu: (provided, state) => ({
            ...provided,
            maxWidth: '100vw',
            overflow: 'auto',
            zIndex: 9999,
        }),
        control: (provided, state) => ({
            ...provided,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            borderRadius: '16px',
            backgroundColor: state.isDisabled ? "#E0E0E0" : state.hasValue ? "#FFF" : state.selectProps.menuIsOpen ? "#FFF" : "rgba(255, 255, 255, 0.10)",
            border: "none",
            padding: '16px 24px',
            minHeight: '56px',
            zIndex: state.isFocused ? 10 : 8,
            boxShadow: 'none',
            opacity: state.isDisabled ? 0.8 : 1,
            '&:hover': {
                borderColor: 'transparent',
            }
        }),
        option: (provided, state) => ({
            ...provided,
            padding: '0',
            color: '#363636',
            cursor: 'pointer',
            position: 'relative',
            fontSize: '16px',
            lineHeight: '130%',
            fontWeight: state.isSelected ? 500 : 400,
            borderBottom: '1px solid #AFAFAF',
            paddingBottom: '12px',
            paddingTop: '12px',
            backgroundColor: 'transparent',
            '&:last-child': {
                borderBottom: 'none',
                paddingBottom: 0
            },
            '&:first-of-type': {
                borderTop: 'none',
                paddingTop: 0
            },
        }),
        // Стили для контейнера иконки
        dropdownIndicator: (provided, state) => ({
            ...provided,
            padding: '0',
        }),
        // Стили для контейнера опций
        menuList: (provided) => ({
            ...provided,
            padding: '16px 24px',
            maxHeight: 'auto',
        }),
        // Стили для плейсхолдера
        placeholder: (provided, state) => ({
            ...provided,
            color: state.hasValue ? '#363636' : state.selectProps.menuIsOpen ? '#363636' : 'rgba(255, 255, 255, 0.70)',
        }),
        // Стили для контейнера значений
        valueContainer: (provided) => ({
            ...provided,
            padding: '0',
        }),
        // Стили для контейнера значений
        singleValue: (provided, state) => ({
            ...provided,
            padding: '0',
            fontFamily: '"Onest","Roboto", "Helvetica", "Arial", sans-serif',
            color: state.isDisabled ? "#999" : "#363636",
            fontSize: '16px',
            fontWeight: 500,
            margin: 0
        }),
    };

    return (
        <Select<SelectOption>
            className={s.selectWrapper}
            classNamePrefix="select"
            value={selectedOption || null}
            onChange={(newValue) => {
                const selectedValue = (newValue as SelectOption)?.value || null;
                onChange(selectedValue);
            }}
            options={selectOptions}
            isClearable={false}
            isSearchable={false}
            isDisabled={disabled}
            placeholder="Выберите показатель"
            noOptionsMessage={({inputValue}) => "Нет доступных опций"}
            styles={customStyles}
            components={{
                IndicatorSeparator: () => null,
                DropdownIndicator
            }}
        />
    );
};